import { Dispatch } from 'redux';
import { Map } from 'immutable';

import { fetcher } from '../../lib/request';

import { City } from '../../models/Food/City';
import { Compilation } from '../../models/Food/Compilation';
import { Tag } from '../../models/Food/Tag';
import { Restaurant } from '../../models/Food/Restaurant';

const FOOD_HOST = process.env.REACT_APP_FOOD_HOST;
const FOOD_KEY = process.env.REACT_APP_FOOD_KEY;

export const RESTAURANT_REQUEST = 'FOOD_RESTAURANT_REQUEST';
export const RESTAURANT_RESPONSE = 'FOOD_RESTAURANT_RESPONSE';
export const RESTAURANT_ERROR = 'FOOD_RESTAURANT_ERROR';

export const RESTAURANTS_LIST_REQUEST = 'FOOD_RESTAURANTS_LIST_REQUEST';
export const RESTAURANTS_LIST_RESPONSE = 'FOOD_RESTAURANTS_LIST_RESPONSE';
export const RESTAURANTS_LIST_ERROR = 'FOOD_RESTAURANTS_LIST_ERROR';

export const RESTAURANTS_LIST_TAG_REQUEST = 'FOOD_RESTAURANTS_LIST_TAG_REQUEST';
export const RESTAURANTS_LIST_TAG_RESPONSE = 'FOOD_RESTAURANTS_LIST_TAG_RESPONSE';
export const RESTAURANTS_LIST_TAG_ERROR = 'FOOD_RESTAURANTS_LIST_TAG_ERROR';

export const RESTAURANTS_MORE_LIST_TAG_REQUEST = 'FOOD_RESTAURANTS_MORE_LIST_TAG_REQUEST';
export const RESTAURANTS_MORE_LIST_TAG_RESPONSE = 'FOOD_RESTAURANTS_MORE_LIST_TAG_RESPONSE';
export const RESTAURANTS_MORE_LIST_TAG_ERROR = 'FOOD_RESTAURANTS_MORE_LIST_TAG_ERROR';

export const COMPILATIONS_REQUEST = 'FOOD_COMPILATIONS_REQUEST';
export const COMPILATIONS_RESPONSE = 'FOOD_COMPILATIONS_RESPONSE';
export const COMPILATIONS_ERROR = 'FOOD_COMPILATIONS_ERROR';

export const CITIES_REQUEST = 'FOOD_CITIES_REQUEST';
export const CITIES_RESPONSE = 'FOOD_CITIES_RESPONSE';
export const CITIES_ERROR = 'FOOD_CITIES_ERROR';

export const RESET_FOOD_FILTER = 'FOOD_RESET_FOOD_FILTER';
export const TOGGLE_FOOD_FILTER = 'FOOD_TOGGLE_FOOD_FILTER';
export const SET_FOOD_FILTER = 'FOOD_SET_FOOD_FILTER';

export const TOGGLE_FOOD_CITY = 'FOOD_TOGGLE_FOOD_CITY';

export const SET_INPUT_VALUE = 'FOOD_SET_INPUT_VALUE';
export const SET_CITY_VALUE = 'FOOD_SET_CITY_VALUE';

export const SET_CITY = 'FOOD_SET_CITY';

export const COMPILATION_REQUEST = 'FOOD_COMPILATION_REQUEST';
export const COMPILATION_RESPONSE = 'FOOD_COMPILATION_RESPONSE';
export const COMPILATION_ERROR = 'FOOD_COMPILATION_ERROR';

export const GET_TIMES_REQUEST = 'FOOD_GET_TIMES_REQUEST';
export const GET_TIMES_RESPONSE = 'FOOD_GET_TIMES_RESPONSE';
export const GET_TIMES_ERROR = 'FOOD_GET_TIMES_ERROR';

export const GET_FILTER_TAGS_REQUEST = 'FOOD_GET_FILTER_TAGS_REQUEST';
export const GET_FILTER_TAGS_RESPONSE = 'FOOD_GET_FILTER_TAGS_RESPONSE';
export const GET_FILTER_TAGS_ERROR = 'FOOD_GET_FILTER_TAGS_ERROR';

interface CompilationsResponse {
    result: {
        compilation: Compilation;
        restaurants: Restaurant[];
    };
    error: any;
}

interface RestaurantResponse {
    result: Restaurant;
    error: any;
}

interface CitiesResponse {
    result: City[];
    error: any;
}

interface AllCompilationsResponse {
    result: Compilation[];
    page: {
        current_page: number;
        next_page: number;
        size: number;
        total_count: number;
        total_pages: number;
    };
}

export const resetFilterAction = () => (dispatch: Dispatch<any>) => {
    dispatch({
        type: RESET_FOOD_FILTER
    });
};

export const getCompilAction = (id: string, city: number, lang: string) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: COMPILATION_REQUEST
    });

    try {
        const response = await fetcher<CompilationsResponse>(`${FOOD_HOST}/v1/compilations/${id}?city_id=${city}&lang=${lang}`)
            .auth(`Basic ${FOOD_KEY}`)
            .json();

        dispatch({
            type: COMPILATION_RESPONSE,
            response: response
        });
    } catch (error) {
        dispatch({
            type: COMPILATION_ERROR,
            error
        });
    }
};  

export const toggleFilterAction = (tag: Tag) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: TOGGLE_FOOD_FILTER,
        tag
    });
};

export const setFilterAction = (tag: Tag) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_FOOD_FILTER,
        tag,
    });
};

export const toggleCityAction = (city: City) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: TOGGLE_FOOD_CITY,
        city
    });
};

export const setInputValueAction = (newValue: string) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_INPUT_VALUE,
        newValue: newValue
    });
};

export const setCityInputAction = (newValue: string) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_CITY_VALUE,
        newValue
    });
};

export const getRestaurantAction = (id: number, lang: string) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: RESTAURANT_REQUEST
    });

    try {
        const response = await fetcher<RestaurantResponse>(`${FOOD_HOST}/v1/restaurants/${id}?lang=${lang}`)
            .auth(`Basic ${FOOD_KEY}`)
            .json();

        dispatch({
            type: RESTAURANT_RESPONSE,
            response: response
        });
    } catch (error) {
        dispatch({
            type: RESTAURANT_ERROR,
            error
        });
    }
};

export const getRestaurantsTagAction = (tags: string, city: number, page?: number) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: RESTAURANTS_LIST_TAG_REQUEST
    });

    try {
        const response = await fetcher<any>(`${FOOD_HOST}/v1/restaurants?${tags ? `tag_ids=${tags}&` : ''}city_id=${city}${page ? `&page=${page}` : ''}`)
            .auth(`Basic ${FOOD_KEY}`)
            .json();

        dispatch({
            type: RESTAURANTS_LIST_TAG_RESPONSE,
            response: response
        });
        return response.result && response.result.length;

    } catch (error) {
        dispatch({
            type: RESTAURANTS_LIST_TAG_ERROR,
            error
        });

        return;
    }
};

export const getMoreRestaurantsTagAction = (tags: string, city: number, page?: number) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: RESTAURANTS_MORE_LIST_TAG_REQUEST
    });

    try {
        const response = await fetcher<any>(`${FOOD_HOST}/v1/restaurants?tag_ids=${tags}&city_id=${city}${page ? `&page=${page}` : ''}`)
            .auth(`Basic ${FOOD_KEY}`)
            .json();

        dispatch({
            type: RESTAURANTS_MORE_LIST_TAG_RESPONSE,
            response: response
        });
    } catch (error) {
        dispatch({
            type: RESTAURANTS_MORE_LIST_TAG_ERROR,
            error
        });
    }
};

export const getCitiesAction = (tariffId: number, lang: string) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: CITIES_REQUEST
    });

    try {
        if (!lang) {
            lang = 'ru';
        }

        const response = await fetcher<CitiesResponse>(`${FOOD_HOST}/v1/cities?lang=${lang}&tariff_id=${tariffId}`)
            .auth(`Basic ${FOOD_KEY}`)
            .json();

        dispatch({
            type: CITIES_RESPONSE,
            response
        });
    } catch (error) {
        dispatch({
            type: CITIES_ERROR,
            error
        });
    }
};

export const getTagsAction = (query: string, city: number, lang: string) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: RESTAURANTS_LIST_REQUEST
    });

    try {
        if (!lang) {
            lang = 'ru';
        }

        const response = await fetcher<any>(`${FOOD_HOST}/v1/multicomplete?q=${query}&city_id=${city}&lang=${lang}`)
            .auth(`Basic ${FOOD_KEY}`)
            .json();

        dispatch({
            type: RESTAURANTS_LIST_RESPONSE,
            response,
        });
    } catch (error) {
        dispatch({
            type: RESTAURANTS_LIST_ERROR,
            error
        });
    }
};

export const getCompilationsAction = (city: number, lang: string) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: COMPILATIONS_REQUEST
    });

    try {
        let flag = true;
        let page = 1;
        let compilations: Map<number, Compilation> = Map<number, Compilation>();
        while (flag) {
            const response = await fetcher<AllCompilationsResponse>(`${FOOD_HOST}/v1/compilations?city_id=${city}&lang=${lang}`)
                .auth(`Basic ${FOOD_KEY}`)
                .json();

            const nextPage = response.page.next_page;
            response.result.forEach(v => compilations = compilations.set(v.id, v));
            nextPage ? page++ : flag = false;
        }

        dispatch({
            type: COMPILATIONS_RESPONSE,
            response: compilations
        });
    } catch (error) {
        dispatch({
            type: COMPILATIONS_ERROR,
            error
        });
    }
};

export const setCityAction = (newValue: number, lang: string) => (dispatch: Dispatch<any>) => {
    dispatch(getCompilationsAction(newValue, lang));
    dispatch({
        type: SET_CITY,
        newValue
    });
};

export const getTimesAction = (id: number, visitors: number, date: string, user: string) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_TIMES_REQUEST
    });

    try {
        const response = await fetcher(`${FOOD_HOST}/v1/times/${id}?visitors=${visitors}&date=${date}&user_id=${user}`)
            .auth(`Basic ${FOOD_KEY}`)
            .json();

        dispatch({
            type: GET_TIMES_RESPONSE,
            response: response
        });
    } catch (error) {
        dispatch({
            type: GET_TIMES_ERROR,
            error
        });
    }
};

export const getFilterTagsAction = (cityId: number) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_FILTER_TAGS_REQUEST
    });

    try {
        const response = await fetcher<any>(`${FOOD_HOST}/v1/tags?city_id=${cityId}`)
            .auth(`Basic ${FOOD_KEY}`)
            .json();

        dispatch({
            type: GET_FILTER_TAGS_RESPONSE,
            response,
        });

        return response.result;
    } catch (error) {
        dispatch({
            type: GET_FILTER_TAGS_ERROR,
            error
        });
    }
};



// WEBPACK FOOTER //
// ./src/actions/Food/restaurants.ts